import { configureStore } from "@reduxjs/toolkit";
import residentialReducer from "./residential";
import ispReducer from "./isp";
import dcIspReducer from "./dataCenter";
import offsetReducer from "./offsets";

const store = configureStore({
  reducer: {
    residential: residentialReducer,
    isp: ispReducer,
    offset: offsetReducer,
    dc: dcIspReducer,
  },
});

export default store;
